import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";

import {withStyles} from "@material-ui/core/styles";
import Button from "../../../components/CustomButtons/Button.jsx";
import GridItem from "../../../components/Grid/GridItem";
import GridContainer from "../../../components/Grid/GridContainer";

//Image Assets
import profile from "assets/img/faces/chwro.jpg";

import {Dictionary} from "../../../database/dictionary";

import aboutStyle from "../../../assets/jss/material-kit-react/views/landingPageSections/aboutStyle";
import Card from "../../../components/Card/Card";
import CardHeader from "../../../components/Card/CardHeader";
import CardBody from "../../../components/Card/CardBody";

class AboutSection extends React.Component {
    render() {
        const {classes} = this.props;
        const imageClasses = classNames(
            classes.imgRaised,
            classes.imgRoundedCircle,
            classes.imgFluid
        );
        return <div className={classes.section}>
            <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={6}>
                    <div className={classes.profile}>
                        <div>
                            <img src={profile} alt="..." className={imageClasses}/>
                        </div>
                        <div className={classes.name}>
                            <h3 className={classes.title}>{Dictionary.name}</h3>
                            <h6>{Dictionary.role}</h6>
                            <Button justIcon link
                                    href={Dictionary.twitter}
                                    target="_blank"
                                    className={classes.margin5}>
                                <i className={"fab fa-twitter"}/>
                            </Button>
                            <Button justIcon link
                                    href={Dictionary.linkedin}
                                    target="_blank"
                                    className={classes.margin5}>
                                <i className={"fab fa-linkedin"}/>
                            </Button>
                            <Button justIcon link
                                    href={Dictionary.instagram}
                                    target="_blank"
                                    className={classes.margin5}>
                                <i className={"fab fa-instagram"}/>
                            </Button>
                        </div>
                    </div>
                </GridItem>
            </GridContainer>
            <div className={classes.description}>
                <p>
                    {Dictionary.bio}{" "}
                </p>
            </div>
            <GridContainer justify={"center"} alignItems={"stretch"} className={classes.grid} spacing={40}>
                <GridItem xs={12} sm={12} md={4}>
                    <Card className={classNames(classes.card, classes.textCenter)}>
                        <CardHeader color="info"><h3>Entrepreneur</h3></CardHeader>
                        <CardBody>
                            <p>
                                {Dictionary.entrepreneur}
                            </p>
                        </CardBody>
                    </Card>
                </GridItem>
                <GridItem xs={12} sm={12} md={4}>
                    <Card className={classNames(classes.card, classes.textCenter)}>
                        <CardHeader color="info"><h3>Developer</h3></CardHeader>
                        <CardBody>
                            <p>
                                {Dictionary.developer}
                            </p>

                            <div className={classes.skills}>
                                <b>Programming: </b>
                                {Dictionary.programming_languages}
                                <br/>
                                <b>VR/AR: </b>
                                {Dictionary.vrar_skills}
                                <br/>
                                <b>Data Science: </b>
                                {Dictionary.datascience_skills}
                                <br/>
                                <b>Frontend/Backend: </b>
                                {Dictionary.front_backend_skills}
                            </div>
                        </CardBody>
                    </Card>
                </GridItem>
                <GridItem xs={12} sm={12} md={4}>
                    <Card className={classNames(classes.card, classes.textCenter)}>
                        <CardHeader color="info"><h3>Speaker</h3></CardHeader>
                        <CardBody>
                            <p>
                                {Dictionary.speaker}
                            </p>
                            <Button color={"action"} href={"/speaker"} simple>My presentations</Button>
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>
        </div>
    }
}

export default withStyles(aboutStyle)(AboutSection);


// WEBPACK FOOTER //
// ./src/views/LandingPage/Sections/AboutSection.jsx